import React, { useState } from 'react'
import { HashLink } from 'react-router-hash-link'
import Icon from '../../ui/Icon/Icon'
import scrollWithOffset from '../../ui/ScrollToTop/scrollWithOffset'
import './CookieNotification.sass'

function CookieNotification() {
  const [acceptedCookie, setAcceptedCookie] = useState(
    localStorage.getItem('acceptedCookies')
  )

  const onCookiesAccept = () => {
    localStorage.setItem('acceptedCookies', true)
    setAcceptedCookie(true)
  }

  return !acceptedCookie ? (
    <div className="Site-CookieNotification">
      <div className="CookieNotification-Container">
        <div className="CookieNotification-Button">
          <Icon name="times" onClick={onCookiesAccept} />
        </div>
        <div className="CookieNotification-Text">
          Этот сайт использует файлы cookie и похожие технологии, чтобы
          гарантировать максимальное удобство пользователям. При использовании
          данного сайта, вы подтверждаете свое согласие на использование файлов
          cookie в соответствии нашей политикой конфиденциальности. Если вы не
          согласны, тогда вам необходимо прекратить использование данного сайта
        </div>
      </div>
    </div>
  ) : null
}

export default CookieNotification
